import { useCallback } from 'react';
import { useUserActionMutation } from './useUserActionMutation';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { HIDE_DIAGNOSTIC_WIDGET_ACTION_TYPE_ID } from '../components/TeacherDashboard/Diagnostic/helper/widgetHelper';

/**
 * Records the action that keeps the diagnostic widget off the dashboard for one class.
 * The caller drops the widget from the current render — this only persists the decision.
 */
export const useHideDiagnosticWidget = () => {
  const userRedux = useAppSelector(selectUser);
  const [commitUserAction] = useUserActionMutation();

  return useCallback(
    (classId: string) => {
      if (!userRedux?.id) return;

      commitUserAction({
        variables: {
          input: {
            userAction: {
              userId: `UserNode:${userRedux.id}`,
              actionTypeId: HIDE_DIAGNOSTIC_WIDGET_ACTION_TYPE_ID,
              timeStamp: new Date().toISOString(),
              description: 'Hide Diagnostic Widget',
              classId,
            },
          },
        },
      });
    },
    [commitUserAction, userRedux?.id],
  );
};
